import { DateSelectOption } from '../../../../../../DateTime'

import { getHasViewingFormSlotPickerDay } from './ViewingFormSlotPickerDay.utils'

function ViewingFormSlotPickerDay({ days, disabled, value, ...restProps }) {
  return (
    <DateSelectOption
      {...restProps}
      disabled={disabled || !getHasViewingFormSlotPickerDay({ days, value })}
      value={value}
    />
  )
}

export default ViewingFormSlotPickerDay
